/**
 * Directive: fileUpload
 *
 *
 */
angular.module('acme.common.directive.upload', [
  'blueimp.fileupload',
  'acme.common.directive.permit',
  'acme.common.service.api'
])
.directive('upload', [function() {

    return {
      restrict: 'AE',
      templateUrl: 'common/directives/upload/upload.tpl.html',
      scope: {
        ngModel: '=',
        permissions: '=',
        currentImageQueue: '=?',
        url: '@',
        name: '@',
        allowed: '@',
        addLabel: '@',
        hideIcon: '@',
        maxFiles: '@',
        sizeLimit: '@',
        autoUpload: '@',
        hideUploadedFiles: '@',
        disallowMultiSelect: '@'
      },
      controller: function ($rootScope, $scope, $element, fileUpload, $timeout, ApiService) {

        var queueWatcher,
            selectedWatcher;

        $scope.currentImageQueue = $scope.currentImageQueue || [];

        $scope.$on('$destroy', function (e, data) {
          queueWatcher();
          selectedWatcher();
        });


        $scope.$on('upload::submit', function (e, data) {
          $scope.submit();
        });


        $scope.$on('fileuploadadd', function (e, data) {
          $timeout(function() {
            console.log('upload::fileuploadadd', data, $scope.currentImageQueue);
            $scope.$emit('upload::add', data);
            $scope.upload.checkFilesErrors(data);
            if ($scope.upload.fileSizeExceededMsg.length) {
              $scope.$emit('upload::error', {
                result: {
                  error: $scope.upload.fileSizeExceededMsg
                }
              });
            }
          }, 500);
        });

        $scope.$on('fileuploadsubmit', function (e, data) {
          console.log('upload::fileuploadsubmit', e, data, $scope.currentImageQueuea);
        });

        $scope.$on('fileuploadsend', function (e, data) {
          console.log('upload::fileuploadsend', e, data, $scope.currentImageQueue);
        });

        $scope.$on('fileuploadalways', function (e, data) {
          console.log('upload::fileuploadalways', e, data, $scope.currentImageQueue);
        });

        $scope.$on('fileuploadstart', function (e, data) {
          console.log('upload::fileuploadstart', e, data, $scope.currentImageQueue);
        });

        $scope.$on('fileuploadstop', function (e, data) {
          console.log('upload::fileuploadstop', e, data, $scope.currentImageQueue);
        });

        $scope.$on('fileuploadprogress', function (e, data) {
          console.log('upload::fileuploadprogress', data, $scope.currentImageQueue);
          $scope.$emit('upload::progress', data);
        });

        $scope.$on('fileuploadprogressall', function (e, data) {
          console.log('upload::fileuploadprogressall', e, data, $scope.currentImageQueue);
        });
        $scope.$on('fileuploadchange', function (e, data) {
          console.log('upload::fileuploadchange', e, data, $scope.currentImageQueue);
        });

        $scope.$on('fileuploaddone', function (e, data) {
          var payload;
          if(data._response.result.payload instanceof Array) {
            payload = data._response.result.payload.slice(0)[0];
          }else {
            payload = angular.copy(data._response.result.payload);
          }
          console.log('upload::fileuploaddone', data, $scope.currentImageQueue);
          fileUpload.addFieldData($scope.name, {
            _id: payload ? payload.uuid : '',
            orig: data.files ? data.files[0] : {},
            file: payload
          });
          $scope.$emit('upload::done', {
            orig: data.files ? data.files.slice(0)[0] : {},
            file: payload
          });
        });

        $scope.$on('fileuploadfail', function (e, data) {
          console.log('upload::fileuploadfail', data, $scope.currentImageQueue);
          $scope.$emit('upload::error', data);
        });

        $scope.options = {
          url: $scope.url,
          dropZone: $element,
          maxFileSize: $scope.sizeLimit,
          maxNumberOfFiles: parseInt($scope.maxFiles, 10),
          autoUpload: $scope.autoUpload,
          selectedFile: 0
        };

        console.log('upload::$scope->options', $scope.addLabel);

        $scope.loadingFiles = false;

        $scope.upload = {

          fileSizeExceededMsg: '',
          btnHighligth: false,

          isPrimary: function(index) {
            console.log('upload::isPrimary', index, $scope.options.selectedFile);
            return (index === parseInt($scope.options.selectedFile, 10));
          },

          remove: function(file, destroy) {

            $scope.$emit('upload::remove', {
              file: file
            });

            if (destroy) {
              file.$destroy();
            }else{
              file.$cancel();
            }

            if ($scope.options.selectedFile > $scope.queue.length - 1) {
              $scope.options.selectedFile = 0;
            }
          },

          hasMultiSelect: function() {
            return ( (parseInt($scope.maxFiles, 10) > 1) && (!$scope.disallowMultiSelect) );
          },

          allowUpload: function() {
            if (!($scope.currentImageQueue instanceof Array)) {
              $scope.currentImageQueue = [];
            }
            return (parseInt($scope.maxFiles, 10) > $scope.currentImageQueue.length);
          },

          fileExceedsMsg: function () {
            return ( (parseInt($scope.maxFiles, 10) > 1)  || (parseInt($scope.maxFiles, 10) === 0) );
          },

          checkFilesErrors: function(data) {
            var r = [];
            if ((data && data.files instanceof Array && data.files.length)) {
              data.files.forEach(function(file) {
                if(file.size > $scope.sizeLimit) {
                  r.push('Unable to upload ' + file.name + ': File size must be 5 Megabytes or less.');
                } else if (file.error) {
                  r.push(file.error);
                }
              });
            }

            if (r.length) {
              this.fileSizeExceededMsg = r.join(' | ');
            } else {
              this.fileSizeExceededMsg = '';
            }
          },

          highlight: function (val) {
            $scope.btnHighligth = val;
          }
        };

        if (!$scope.queue) {
          $scope.queue = [];
        }

        function generateFileObject (objects) {
          angular.forEach(objects, function (value, key) {

            $scope.queue[key] = {
              id: value.file ? value.file.uuid : '',
              name: value.file ? value.file.originalFileName : '',
              size: value.orig.size,
              url: value.file ? value.file.originalPath : '',
              thumbnailUrl: value.file ? value.file.thumbnailPath : '',
              result: value
            };
          });
          console.log('upload::queue', $scope.queue);
        }
        fileUpload.registerField($scope.name);
        fileUpload.fieldData[$scope.name] = [];
        $scope.filequeue = fileUpload.fieldData[$scope.name];

        selectedWatcher = $scope.$watch('options.selectedFile', function(newval) {
          $scope.$emit('upload::selectionChange', { file: $scope.queue[newval] });
        });

        queueWatcher = $scope.$watchCollection('filequeue', function (newval) {
          generateFileObject(newval);
          $scope.$emit('upload::queueUpdated', { queue: newval });
        });
      }
    };

}]).controller('FileDestroyController', ['$rootScope', '$scope', '$http', 'fileUpload', 'ApiService', function ($rootScope, $scope, $http, fileUpload, ApiService) {
    var file = $scope.file,
      state;

    if ($scope.$parent && $scope.$parent.$parent && $scope.$parent.$parent.$parent.name) {
      $scope.fieldname = $scope.$parent.$parent.$parent.name;
    }

    if (!fileUpload.fieldData[$scope.name]) {
      fileUpload.fieldData[$scope.name] = [];
    }

    $scope.filequeue = fileUpload.fieldData;

    $scope.$on('upload::delete', function (e, data) {
      console.log('upload::delete', $scope.filequeue, $scope.fieldname, data.file.uuid);

      ApiService.photos.remove(data.file.uuid).then(function() {
        var i, ii;
        for (i=0,ii=$scope.filequeue[$scope.fieldname].length;i<ii;i++) {
          if ($scope.filequeue[$scope.fieldname][i]._id === data.file.uuid) {
            fileUpload.removeFieldData($scope.fieldname, data.file.uuid);
            console.log('upload::delete', $scope.filequeue[$scope.fieldname][i], $scope.fieldname, data.file.uuid);
            $scope.clear(file);
          }
        }
      });
    });

    if (file.url) {
      file.$state = function () {
        return state;
      };
      file.$destroy = function () {
        state = 'pending';
        return ApiService.photos.remove(file.id).then(
          function () {
            state = 'resolved';
            fileUpload.removeFieldData($scope.fieldname, file.result._id);
            $scope.clear(file);
          },
          function () {
            state = 'rejected';
            fileUpload.removeFieldData($scope.fieldname, file.result._id);
            $scope.clear(file);
          }
        );


      };
    } else if (!file.$cancel && !file._index) {
      file.$cancel = function () {
        $scope.clear(file);
      };
    }
  }
]);
